export interface CalendarDay {
  day: string;
  date: string;
  items: {
    title: string;
    chapter: string;
    time: string;
    category: string;
  }[];
}

export const calendarDays: CalendarDay[] = [
  {
    day: '周一',
    date: '08-18',
    items: [
      { title: '山海异闻志', chapter: '更新至 110 话', time: '09:00', category: '热血冒险' },
      { title: '萌宠日常部', chapter: '更新至 120 话', time: '08:00', category: '搞笑治愈' },
    ],
  },
  {
    day: '周二',
    date: '08-19',
    items: [
      { title: '深夜侦探社', chapter: '更新至 89 话', time: '21:30', category: '悬疑惊悚' },
      { title: '少年御剑录', chapter: '更新至 96 话', time: '17:00', category: '热血冒险' },
    ],
  },
  {
    day: '周三',
    date: '08-20',
    items: [
      { title: '星海拾光', chapter: '更新至 76 话', time: '20:00', category: '科幻奇幻' },
      { title: '雨巷咖啡馆', chapter: '更新至 33 话', time: '15:00', category: '恋爱日常' },
    ],
  },
  {
    day: '周四',
    date: '08-21',
    items: [
      { title: '时空信使', chapter: '更新至 64 话', time: '19:00', category: '科幻奇幻' },
    ],
  },
  {
    day: '周五',
    date: '08-22',
    items: [
      { title: '剑与星辰', chapter: '更新至 128 话', time: '18:30', category: '热血冒险' },
      { title: '迷雾禁区', chapter: '更新至 58 话', time: '23:00', category: '悬疑惊悚' },
    ],
  },
  {
    day: '周六',
    date: '08-23',
    items: [
      { title: '甜点师的告白', chapter: '更新至 52 话', time: '12:00', category: '恋爱日常' },
      { title: '云端便利店', chapter: '更新至 29 话', time: '22:00', category: '恋爱日常' },
    ],
  },
  {
    day: '周日',
    date: '08-24',
    items: [
      { title: '魔王大人营业中', chapter: '更新至 41 话', time: '10:30', category: '搞笑治愈' },
    ],
  },
];